module.exports = __webpack_public_path__ + "static/media/improve-school-1.3917ab1a.jpeg";